import React from 'react'

const UserProfile = () => {
    return (
        <div>
            userProffile
        </div>
    )
}

export default UserProfile
